export var STREAMING_TYPE;
(function (STREAMING_TYPE) {
    STREAMING_TYPE["QUOTE"] = "quote";
    STREAMING_TYPE["QUOTE2"] = "quote2";
    STREAMING_TYPE["MARKETDEPTH"] = "quote2";
    STREAMING_TYPE["MINIQUOTE"] = "miniquote";
    STREAMING_TYPE["NOTIFICATION"] = "notification";
    STREAMING_TYPE["NEWS"] = "news";
    STREAMING_TYPE["ADVDEC"] = "advanceDecline";
    STREAMING_TYPE["MARKET_STATUS"] = "marketstatus";
    STREAMING_TYPE["TOTP"] = "totp";
})(STREAMING_TYPE || (STREAMING_TYPE = {}));
